import React, { PropsWithChildren } from 'react'

const RequiredLabelWrapper = ({ children }: PropsWithChildren) => {
  return (
    <div className='flex gap-1'>
      {children} <span className='text-red-500'>*</span>
    </div>
  )
}

export default RequiredLabelWrapper
